// extracted by mini-css-extract-plugin
export default {"mainContainer":"exotel_mainContainer__GWee0","leftSubContainer":"exotel_leftSubContainer__LMAle","rightSubContainer":"exotel_rightSubContainer__xYG5t"};